<template>
  <div class="nav">
    <div class="nav__header">
      <div class="nav__avatar">
        <span class="nav__avatar-text">付</span>
      </div>
      <div class="nav__header-text">
        <div class="nav__title">付无忧</div>
        <div class="nav__sub">代理商管理后台</div>
      </div>
    </div>
    <div class="nav__divider"></div>
    <div class="nav__body">
      <div
        v-for="item in menuList"
        :key="item.path"
        class="nav__item"
        :class="{ 'is-active': isActive(item) }"
        @click="go(item)">
        <span class="nav__icon-box">
          <i :class="item.icon" class="nav__icon"></i>
        </span>
        <span class="nav__label">{{ item.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  computed: {
    userInfo() {
      return this.$store.getters.userInfo || {}
    },
    menuList() {
      const routes = this.$router.options.routes
      const list = []
      routes.forEach(item => {
        if (!item.meta || item.meta.hidden) return
        const auth = item.meta.auth || []
        const allowed = auth.length === 0 || auth.some(prefix => (this.userInfo.agentId || '').startsWith(prefix))
        if (!allowed) return
        if (!item.children) {
          list.push({
            path: item.path,
            link: item.path,
            title: item.meta.title,
            icon: item.meta.icon,
            isNew: item.meta.isNew
          })
          return
        }
        const visibleChildren = item.children.filter(c => !c.meta.hidden)
        if (visibleChildren.length === 0) return
        const child = visibleChildren[0]
        const link = child.path === '' ? item.path : `${item.path}/${child.path}`
        list.push({
          path: item.path,
          link,
          title: item.meta.title,
          icon: item.meta.icon,
          isNew: child.meta.isNew
        })
      })
      return list
    }
  },
  methods: {
    isActive(item) {
      return this.$route.fullPath.startsWith(item.link)
    },
    go(item) {
      this.$router.push(item.link)
    }
  }
}
</script>

<style scoped>
.nav {
  width: 280px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
}
.nav__header {
  height: 64px;
  flex-shrink: 0;
  background: #F7F8F9;
  display: flex;
  align-items: center;
  padding: 0 20px;
  gap: 12px;
}
.nav__avatar {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: linear-gradient(135deg, #FC6C3C 0%, #E55A2A 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  font-weight: 700;
  flex-shrink: 0;
}
.nav__header-text {
  flex: 1;
  min-width: 0;
}
.nav__title {
  font-size: 15px;
  font-weight: 700;
  color: #344054;
  line-height: 1.3;
}
.nav__sub {
  font-size: 11px;
  color: #A3B1CE;
  line-height: 1.3;
  margin-top: 1px;
}
.nav__divider {
  height: 1px;
  background: #EDF0F2;
  flex-shrink: 0;
}
.nav__body {
  flex: 1;
  background: #FFFFFF;
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow-y: auto;
}
.nav__item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  min-height: 42px;
  box-sizing: border-box;
}
.nav__item:hover {
  background: #F5F6F7;
}
.nav__item.is-active {
  background: #FC6C3C;
}
.nav__icon-box {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #F5F6F7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;
}
.nav__icon {
  font-size: 16px;
  color: #667085;
  transition: color 0.2s;
}
.nav__item:hover .nav__icon-box {
  background: #E8E9EB;
}
.nav__item:hover .nav__icon {
  color: #FC6C3C;
}
.nav__item.is-active .nav__icon-box {
  background: rgba(255,255,255,0.2);
}
.nav__item.is-active .nav__icon {
  color: #FFF;
}
.nav__label {
  font-size: 14px;
  color: #667085;
  font-weight: 500;
  line-height: 1;
  transition: color 0.2s;
}
.nav__item:hover .nav__label {
  color: #FC6C3C;
}
.nav__item.is-active .nav__label {
  color: #FFF;
  font-weight: 600;
}
</style>
